import $axios from "@/plugins/axios-instance";

export default {
  state: {
    organizationInfo: {
      hasSite: null
    },
    organizationListContacts: {}
  },
  getters: {
    getOrganizationListContacts(state) {
      return state.organizationListContacts;
    },
    getOrganizationInfo(state) {
      return state.organizationInfo;
    },
    getOrganizationName(state) {
      return state.organizationInfo.organizationName || "Организация";
    }
  },
  actions: {
    organization(context, data) {
      return $axios
        .get("/Organization/GetInfo")
        .then(response => {
          context.state.organizationInfo = response.data;
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    organizationSaveInfo(context, data) {
      return $axios
        .post("/Organization/SaveInfo", data)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    organizationListContacts(context, data) {
      return $axios
        .get("/Organization/ListContacts")
        .then(response => {
          context.state.organizationListContacts = response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },

    organizationDeleteContact(context, data) {
      return $axios
        .post(`/Organization/DeleteContact/${data.id}`)
        .then(response => {
          context.state.organizationListContacts.splice(data.index, 1);
        })
        .catch(e => {
          throw e.response;
        });
    },

    organizationUpdateOrCreateContact(context, data) {
      return $axios
        .post("/Organization/UpdateOrCreateContact", data.form)
        .then(response => {
          if (data.edit) {
            for (let key in data.form) {
              context.state.organizationListContacts[data.index][key] =
                data.form[key];
            }
          } else {
            context.state.organizationListContacts.push(response.data);
          }
        })
        .catch(e => {
          throw e.response;
        });
    }
  }
};
